/* ============================================================
   ShopSpark Theme – Main JavaScript
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {

  /* ---- Mobile menu toggle ---- */
  const mobileToggle = document.querySelector('.mobile-menu-toggle');
  const mobileNav = document.querySelector('.mobile-nav');
  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener('click', function () {
      const isOpen = mobileNav.classList.toggle('open');
      mobileToggle.setAttribute('aria-expanded', isOpen);
    });
  }

  /* ---- Sticky header shadow ---- */
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  /* ---- Product gallery thumbnails ---- */
  const thumbs = document.querySelectorAll('.product-gallery__thumb');
  const mainImg = document.querySelector('.product-gallery__main img');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      thumbs.forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
      if (mainImg) {
        mainImg.src = thumb.querySelector('img').src;
      }
    });
  });

  /* ---- Quantity stepper ---- */
  document.querySelectorAll('.qty-control').forEach(function (ctrl) {
    const input = ctrl.querySelector('.qty-input');
    ctrl.querySelector('.qty-increase')?.addEventListener('click', function () {
      input.value = parseInt(input.value || 1) + 1;
    });
    ctrl.querySelector('.qty-decrease')?.addEventListener('click', function () {
      const val = parseInt(input.value || 1);
      if (val > 1) input.value = val - 1;
    });
  });

  /* ---- Add to cart AJAX ---- */
  document.querySelectorAll('.product-add-form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const btn = form.querySelector('[data-add-to-cart]');
      const originalText = btn ? btn.textContent : '';
      if (btn) { btn.textContent = 'Adding…'; btn.disabled = true; }

      const formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          showCartNotification();
          updateCartCount();
          if (btn) { btn.textContent = 'Added!'; }
          setTimeout(function () {
            if (btn) { btn.textContent = originalText; btn.disabled = false; }
          }, 2000);
        })
        .catch(function (err) {
          console.error('Add to cart failed', err);
          if (btn) { btn.textContent = originalText; btn.disabled = false; }
        });
    });
  });

  /* ---- Cart count ---- */
  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-count').forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      });
  }
  updateCartCount();

  /* ---- Cart notification ---- */
  function showCartNotification() {
    const notif = document.getElementById('cart-notification');
    if (!notif) return;
    notif.style.display = 'block';
    clearTimeout(notif._timeout);
    notif._timeout = setTimeout(function () {
      notif.style.display = 'none';
    }, 4000);
  }

  /* ---- Product option selection ---- */
  document.querySelectorAll('.product-options__swatch').forEach(function (swatch) {
    swatch.addEventListener('click', function () {
      const group = swatch.closest('.product-options__swatches');
      group.querySelectorAll('.product-options__swatch').forEach(function (s) { s.classList.remove('active'); });
      swatch.classList.add('active');
    });
  });

  /* ---- Newsletter form ---- */
  const newsletterForm = document.querySelector('.newsletter-form');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const email = newsletterForm.querySelector('input[type="email"]').value;
      if (!email) return;
      const btn = newsletterForm.querySelector('button');
      btn.textContent = 'Subscribed! 🎉';
      btn.disabled = true;
    });
  }

  /* ---- Smooth scroll for anchor links ---- */
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      const target = document.querySelector(a.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* ---- Animate on scroll (lightweight IntersectionObserver) ---- */
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    document.querySelectorAll('.product-card, .trust-badge, .collection-card').forEach(function (el) {
      observer.observe(el);
    });
  }

});
